import * as React from 'react'

import { Box, Colors, LegendItem, Text } from '@factorialco/deprecated-design-system'

type Props = {
  color: Colors
  name: string
  value: number | string
}

const TooltipLegend = ({ color, name, value }: Props) => {
  return (
    <LegendItem color={color} flexDirection="row" gap="s4" alignItems="center">
      <Box alignItems="flexStart" width="s120" flexGrow>
        <Text capitalize size="200" weight="medium" color="grey100">
          {name}
        </Text>
      </Box>
      <Box>
        <Text size="200" weight="medium" color="grey100">
          {value}
        </Text>
      </Box>
    </LegendItem>
  )
}

export default TooltipLegend
